import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { addDisplayName } from "../Infra/display-name";
import { DocumentRetrievalViewModel, DocumentRetrievalStep } from "./DocumentRetrievalViewModel";
import { ProgressLoadingScreen } from "./ProgressLoadingScreen";
import { DocumentRetrievalRecordsFound } from "./DocumentRetrievalRecordsFound";
import { DocumentRetrievalRecordsNotFound } from "./DocumentRetrievalRecordsNotFound";
import { DocumentRetrievalContinueWithoutSharing } from "./DocumentRetrievalContinueWithoutSharing";
import { DocumentRetrievalReviewAndShare } from "./DocumentRetrievalReviewAndShare";
import { DocumentRetrievalHURLoading } from "./DocumentRetrievalHURLoading";
import { DocumentRetrievalLoginLocation } from "./DocumentRetrievalLoginLocation";
import { useViewModel } from "./useViewModel";
import { DocumentRetrievalTechnicalErrorView } from "./DocumentRetrievalTechnicalErrorView";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
export const DocumentRetrievalView = observer((props) => {
    var _a;
    const model = useViewModel(DocumentRetrievalViewModel, props.container);
    if (props.stepToShow) {
        model.uiState.stepToShow = props.stepToShow;
    }
    model.onRecordsShared = props.onRecordsShared;
    if (props.staticRetrievalData) {
        model.uiState.isStatic = true;
        model.uiState.staticRetrievalData = props.staticRetrievalData;
    }
    else {
        model.uiState.patientId = (_a = props.patientId) !== null && _a !== void 0 ? _a : null;
        model.uiState.studyId = props.studyId;
    }
    const handleFastenCallback = async (event) => {
        await model.handleFastenCallback(event.detail.data);
    };
    React.useEffect(() => {
        window.addEventListener("eventBus", handleFastenCallback, true);
        return () => {
            window.removeEventListener("eventBus", handleFastenCallback);
        };
    }, []);
    return renderStepContent(model.currentStep);
    function renderStepContent(step) {
        switch (step) {
            case DocumentRetrievalStep.RESTORING_SESSION:
                return renderRestoringStateScreen();
            case DocumentRetrievalStep.LOADING:
                return renderLoadingScreen();
            case DocumentRetrievalStep.TECHNICAL_ERROR:
                return renderTechnicalErrorScreen();
            case DocumentRetrievalStep.RECORDS_NOT_FOUND:
                return renderRecordsNotFoundScreen();
            case DocumentRetrievalStep.RECORDS_FOUND:
                return renderRecordsFoundScreen();
            case DocumentRetrievalStep.REVIEW_AND_SHARE:
                return renderReviewLocationsScreen();
            case DocumentRetrievalStep.CONTINUE_WITHOUT_SHARING:
                return renderContinueWithoutSharingScreen();
            case DocumentRetrievalStep.LOCATION_LOGIN:
                return renderLocationLoginScreen();
            case DocumentRetrievalStep.HUR_LOADING:
                return renderHurLoadingScreen();
            default:
                return renderReviewLocationsScreen();
        }
    }
    function renderRestoringStateScreen() {
        return _jsx(LoadingPlaceholder, { w: 10, h: 60, center: true });
    }
    function renderLoadingScreen() {
        return _jsx(ProgressLoadingScreen, { title: model.loadingTitle, subtitle: model.loadingSubTitle, progress: model.loadingProgress });
    }
    function renderTechnicalErrorScreen() {
        return _jsx(DocumentRetrievalTechnicalErrorView, { model: model });
    }
    function renderRecordsNotFoundScreen() {
        return (_jsx(DocumentRetrievalRecordsNotFound, { onAddAnotherClicked: props.onAddAnotherClicked, onContinueWithoutSharing: () => model.continueFromRecordsNotFound(), isDataUpdate: model.isDataUpdate, canAddLocations: model.canAddLocations, recordCount: model.recordsFoundCount, locationCount: model.locationsFoundCount, isIAS: model.isIAS, animate: model.animate, fastenPublicId: model.fastenPublicId, fastenPatientId: model.fastenPatientId, isStatic: model.uiState.isStatic }));
    }
    function renderRecordsFoundScreen() {
        return (_jsx(DocumentRetrievalRecordsFound, { onContinue: () => model.continueFromRecordsFound(), isDataUpdate: model.isDataUpdate, recordCount: model.recordsFoundCount, locationCount: model.locationsFoundCount, isIAS: model.isIAS, animate: model.animate }));
    }
    function renderReviewLocationsScreen() {
        return _jsx(DocumentRetrievalReviewAndShare, { model: model });
    }
    function renderContinueWithoutSharingScreen() {
        return (_jsx(DocumentRetrievalContinueWithoutSharing, { fastenPublicId: model.fastenPublicId, fastenPatientId: model.fastenPatientId, isStatic: model.uiState.isStatic, isIAS: model.isIAS, onConfirmContinue: async () => await model.confirmContinueWithoutSharing(), onAddAnotherClicked: props.onAddAnotherClicked, organizationName: model.organizationName }));
    }
    function renderLocationLoginScreen() {
        return _jsx(DocumentRetrievalLoginLocation, { model: model });
    }
    function renderHurLoadingScreen() {
        return _jsx(DocumentRetrievalHURLoading, { model: model });
    }
});
addDisplayName(DocumentRetrievalView, "DocumentRetrievalView");
